<template>
  <div class="historyBox">
    <Header />
    <div class="listBox">
      <img
        v-if="historyList.length == 0"
        src="./assets/images/historyEmpty.png"
        alt=""
      />
      <ul v-else>
        <li v-for="(item, index) in historyList" :key="index">
          <!-- head title -->
          <div class="headTitle">
            <h5>Estado de pedido</h5>
            <p>Verificando</p>
          </div>
          <!-- amount -->
          <div class="amountBox">
            <p>Monto de préstasmo</p>
            <h3>S/{{ $setNum(item.loanAmount) }}</h3>
            <div style="display:flex;justify-content: space-between">
              <p>Fecha de pago: {{ item.repayDate }}</p>
              <p @click="launchDetail(item)">
                Detalles
                <van-icon style="transform:rotate(90deg)" name="play" />
              </p>
            </div>
          </div>
          <div
            :style="{ visibility: item.detailShow ? 'visible' : 'hidden' }"
            class="divider"
          ></div>
          <!-- Deatil information -->
          <div
            class="information"
            :style="{ height: item.detailShow ? '4.4rem' : 0 }"
          >
            <ul>
              <li>
                <p>Monto de préstamo</p>
                <p>S/{{ $setNum(item.loanAmount) }}</p>
              </li>
              <li>
                <p>Monto total a pagar</p>
                <p>S/{{ $setNum(item.totalAmount) }}</p>
              </li>
              <li>
                <p>Interés</p>
                <p>S/{{ item.interest }}</p>
              </li>
              <li>
                <p>Comisión</p>
                <p>S/{{ item.serviceFee }}</p>
              </li>
              <li>
                <p>IGV</p>
                <p>S/{{ item.vat }}</p>
              </li>
              <li>
                <p>Interés moratorio</p>
                <p>S/{{ item.penaltyFee }}</p>
              </li>
              <li>
                <p>Monto pagado</p>
                <p>S/{{ item.period }}</p>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <ContactOrAbout />
  </div>
</template>

<script>
import Header from "./components/header.vue";
import ContactOrAbout from "./components/contactOrAbout.vue";
import { getHistoryOrderList } from "../utils/api/h5page";
export default {
  name: "",
  components: {
    Header,
    ContactOrAbout,
  },
  props: {},
  data() {
    return {
      historyList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getOrderList();
  },
  methods: {
    launchDetail(row) {
      this.historyList.forEach((item) => {
        if (item.orderId == row.orderId) {
          item.detailShow = !item.detailShow;
        }
      });
    },
    // 获取订单列表
    getOrderList() {
      getHistoryOrderList().then(({ data }) => {
        if (data.code == 0) {
          this.historyList = data.data.orderData.map((item) => {
            return { ...item, detailShow: false };
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.historyBox {
  background: #f5f5f5;
  padding: 0 0.2rem 0.42rem;
}

.listBox {
  width: 100%;
  margin-top: 0.4rem 0 0.3rem;
  img {
    width: 100%;
  }
  & > ul {
    & > li {
      width: 6.6rem;
      min-height: 3.12rem;
      background: #ffffff;
      border-radius: 0.14rem;
      overflow: hidden;
      .headTitle {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-bottom: 0.01rem solid #e7e7e7;
        padding: 0.18rem 0.32rem;
        h5 {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 0.22rem;
          color: #333333;
        }
        p {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 0.22rem;
          color: #c90000;
        }
      }

      .amountBox {
        padding: 0.34rem 0.32rem 0;
        h3 {
          font-family: Roboto, Roboto;
          font-weight: 700;
          font-size: 0.5rem;
          color: #333333;
          margin: 0.2rem 0 0.25rem;
        }
        p {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 0.26rem;
          color: #666666;
        }
      }
      .divider {
        width: 5.91rem;
        height: 0.01rem;
        border: 0.02rem dashed #e7e7e7;
        margin: 0.35rem auto 0;
      }
      .information {
        transition: all 0.3s;
        ul {
          padding: 0 0.43rem;
          margin-top: 0.29rem;
          li {
            display: flex;
            justify-content: space-between;
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 0.28rem;
            color: #666666;
            margin-bottom: 0.25rem;
            p {
              font-family: Roboto, Roboto;
              font-weight: 400;
              font-size: 0.28rem;
              color: #666666;
            }
          }
        }
      }
    }
  }
}
</style>
